<template>
  <div>
    <div class="content-header">
      <div class="clearfix">
        <h1 class="m-0 text-dark">{{ $t('psTitle')}}</h1>
      </div>
    </div>

    <div class="content pl-1">
      <div class="container-fluid">
        <v-client-table :data="investmentDetails" 
          :columns="tableHeaders"
          :options="options">
          <a slot="action" slot-scope="props">
            <button @click="openStatusModal(props.row)" class="btn btn-info payment-btn text-uppercase">{{ $t('table.edit')}}</button>
          </a>
        </v-client-table>

        <p class="vue-pagination-ad"></p>

        <!-- Modal Section Start-->
        <div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <form @submit.prevent="saveStatus">
                  <div class="card-body text-center">
                    <p class="text-danger float-right" data-dismiss="modal" aria-label="Close">close</p>
                    <h4 class="card-text mt-3">{{ pInterestDetail.repaymentDate | moment("YYYY") }} Q {{ pInterestDetail.quarter}}</h4>
                    <h5 class="card-text mb-3">{{ $t('upPaymentInterest')}}</h5>
                    <div>
                      <select v-on:click="changeStatus($event)" v-model.lazy="pInterestDetail.status" class="custom-select mb-3 col-lg-10 col-md-10">
                        <option
                          v-for="(status, idx) in interestStatus"
                          :key="idx"
                          :value="status"
                          :selected="true"
                        >{{ status }}</option>
                      </select>
                    </div>
                    <button type="submit" class="btn btn-success payment-btn mng-schedule-btn my-4">{{ $t('table.save')}}</button>
                    <div>{{ savingResponse }}</div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Section End -->

        <h5 class="text-danger text-center my-4">{{ noPaymentData }}</h5>
        <div class="middle-content">
          <div class="content">
            <div class="row mb-3">
              <div class="col-2">
                <span class="text-lg">{{ $t('psDueDate')}}: </span>
              </div>
              <input readonly="readonly" id="selectedStartDate" type="text" autocomplete="off" class="col-2 form-control bg-white">
            </div>
            <div class="row">
              <div class="col-2">
                <span class="text-lg">{{ $t('psTo')}}: </span>
              </div>
              <input id="selectedEndDate" readonly="readonly" type="text" autocomplete="off" class="col-2 form-control bg-white">
            </div>
            <div class="row mb-3">
              <div class="col-2">
              </div>
              <small>
                <a href="#" @click="resetFilter">reset filter</a>
              </small>
            </div>
            <div class="row mb-3">
              <div class="col-2">
              </div>
              <button v-on:click="search" class="btn btn-warning text-dark payment-btn">{{ $t('psSearch')}}</button>
            </div>

            <div class="mt-2">
              <h2>Total: {{ interestData.totalAllInterest | displayAmount(interestData.currency) }}<span class="text-danger">{{ noTotalData}}</span></h2>
              <h5>{{ $t('psPaid')}}: {{ interestData.totalInterestPaid | displayAmount(interestData.currency) }}<span class="text-danger">{{ noTotalData}}</span></h5>
              <h5>{{ $t('psUnpaid')}}: {{ interestData.totalInterestUnpaid | displayAmount(interestData.currency) }}<span class="text-danger">{{ noTotalData}}</span></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate.vue'

export default {
  name: "PaymentSchedule",
  components: {
    Paginate
  },
  data() {
    return {
      number: 0,
      investmentDetails: [],
      interestData: {},
      pDetailId: {},
      pDetailToChange: [],
      pInterestDetail: [],
      tempStatus: '',
      interestStatus: ["unpaid", "paid", "pending_authorize"],
      selectedStartDate: '',
      selectedEndDate: '',
      noPaymentData: '',
      noTotalData: '',
      savingResponse: '',
      tableHeaders: ['no', 'priorityUser.name', 'quarter', 'repaymentDate', 'interestAmount', 'status', 'action'],
      options: {
        sortable: ['name', 'priorityUser.name', 'quarter', 'repaymentDate', 'interestAmount', 'status'],
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        headings: {
          'priorityUser.name': 'Name',
          'repaymentDate': 'Date',
          'interestAmount': 'Nominal'
        },
        templates: {
          quarter(h, row) {
            return `${this.$t('table.interest')} Q${row.quarter}`
          },
          repaymentDate(h, row) {
            return this.$options.filters.displayDate(row.repaymentDate)
          },
          interestAmount(h, row) {
            return this.$options.filters.displayAmount(row.interestAmount, row.priorityInvestment.currency)
          },
          no(h, row, idx) {
            return idx
          }
        }
      }
    }
  },
  mounted: function() {
    var self = this;
    $("#selectedStartDate").datepicker({
      dateFormat: 'dd M yy',
      onSelect:function(selectedDate, selectedStartDate) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.selectedStartDate = formatSelectedDate;
      }
    });
    $("#selectedEndDate").datepicker({
      dateFormat: 'dd M yy',
      onSelect:function(selectedDate, selectedEndDate) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.selectedEndDate = formatSelectedDate;
      }
    });
    this.search();
    this.totalInterest(); 
  },
  methods: {
    search: function() {
      let paymentScheduleUrl = '/admin/v1/priority/payment-schedule'
      if (this.selectedStartDate !== '' && this.selectedEndDate !== '') {
        paymentScheduleUrl = '/admin/v1/priority/payment-schedule?startDate='+this.selectedStartDate+'&endDate='+this.selectedEndDate
      }
      this.$axios.get(paymentScheduleUrl)
      .then(res => {
        this.investmentDetails = res.data.data;
      })
      .catch(error => {
        this.noPaymentData = 'Data tidak dapat ditampilkan'
      }) 
    },
    totalInterest: function() {
      this.$axios.get('/admin/v1/priority/payment-schedule/total-interest')
      .then(res => {
        this.interestData = res.data.data;
      })
      .catch(error => {
        this.noTotalData = 'Data tidak dapat ditampilkan'
      })
    },
    statusColorClass(displayColorStatus) {
      let status = ''
      if( displayColorStatus == "paid"){
        status = 'text-success'
      } else if(displayColorStatus == "unpaid") {
        status = 'text-danger'
      } else if (displayColorStatus == "pending_authorize") {
        status = 'text-warning'
      }
      return status
    },
    changeStatus(status) { //change status on card
      this.pInterestDetail.status = status.target.value
      this.pInterestDetail.tempStatus = this.tempStatus
    },
    saveStatus() {
      let dataToUpdate = this.pInterestDetail
      this.$axios.put(`/admin/v1/priority/payment-schedule/interest-detail/${this.pInterestDetail._id}`, dataToUpdate)
      .then (res => {
        this.$swal({ type: "success", text: "Status berhasil disimpan" })
        this.search()
        this.totalInterest()
      })
      .catch(error => {
        this.$swal({ type: "warning", text: "Update status failed. " + error})
      })
    },
    resetFilter() {
      this.selectedStartDate = ''
      this.selectedEndDate = ''
      $("#selectedStartDate").val('')
      $("#selectedEndDate").val('')
      this.search()
    },
    openStatusModal(interestData) {
      $("#statusModal").modal('show');
      this.pInterestDetail = interestData
      this.tempStatus = this.pInterestDetail.status
    }
  }
}

</script>

<style>

@media screen and (min-width: 768px) {
  #list-schedule-horizontal {
    width: 100%;
  }
  .payment-btn {
    padding: 5px 25px;
    border-radius: 25px;;
  }
}

@media screen and (max-width: 767px) {
  .header-form-schedule-info {
    font-size: 25px;
    text-align: center;
  }
  #list-schedule-horizontal {
    width: 767px;
    border: 1px solid;
    border-color: rgb(214, 214, 214);
  }
  .payment-btn {
    padding: 5px 25px;
    border-radius: 25px;;
  }
}
</style>